export const GOOGLE_PAY_MERCHANT_ID = '01549207589912858941';
export const GOOGLE_PAY_MERCHANT_NAME = 'Eventbrite';

export const GOOGLE_PAY_SHARED_PAYLOAD: Pick<
    google.payments.api.PaymentDataRequest,
    'apiVersion' | 'apiVersionMinor' | 'emailRequired'
> & {
    allowedPaymentMethods: google.payments.api.IsReadyToPayPaymentMethodSpecification[];
} = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
        {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
                billingAddressRequired: true,
            },
        },
    ],
    emailRequired: true,
};
